<ng-container *ngIf="previousSearches$ | async as previousSearches">
  <div *ngIf="previousSearches.length > 0" data-test-previous-searches>
    <h3
      id="previous-searches-title"
      class="grey-50-bg rounded-small pr-large-x ps-medium-y font-body-1 nordic-blue-900-text"
    >
      {{ 'bookingSearch.previousSearches' | finLocalization }}
    </h3>

    <ul [attr.id]="'previousSearches'" class="flex flex--column" role="list" aria-labelledby="previous-searches-title">
      <li
        *ngFor="let search of previousSearches; let last = last; let index = index"
        class="flex flex--middle flex--space-between focus-inset link-hover pr-large-x"
        [class.border-bottom]="!last"
        role="listitem"
        data-test-previous-search-item
        [id]="'previous-search-' + index"
      >
        <button
          #previousSearchItems
          class="flex flex-1 flex--column ps-medium-y overflow-hidden"
          (click)="setSearch(search)"
          [attr.aria-label]="
            'bookingSearch.selectPreviousSearch'
              | finLocalization
                : {
                    origin: search?.origin?.cityName,
                    destination: search?.destination?.cityName,
                    date:
                      (search.travelDates.departureDate | finDateFormat: 'DATE').toString() +
                      (search?.travelDates?.returnDate
                        ? ' - ' + (search?.travelDates?.returnDate | finDateFormat: 'DATE')?.toString()
                        : '')
                  }
          "
          data-test-previous-search-set-item
        >
          <div class="font-body-1 capitalize location-title">
            <div *ngIf="search" class="flex fill">
              <span class="ps-xxsmall-r overflow-hidden truncate">{{ search?.origin?.cityName }}</span>
              <span
                >({{
                  search?.origin?.locationCode && search?.origin?.type === 'airport'
                    ? search?.origin?.locationCode
                    : ('bookingSearch.allAirportsLabel' | finLocalization)
                }})</span
              >
              <span class="overflow-hidden truncate"> - {{ search?.destination?.cityName }}</span>
              <span
                >({{
                  search?.destination?.locationCode && search?.destination?.type === 'airport'
                    ? search?.destination?.locationCode
                    : ('bookingSearch.allAirportsLabel' | finLocalization)
                }})</span
              >
            </div>
          </div>
          <div class="font-body-2 ps-xxsmall-y nordic-blue-900-text">
            {{ search?.travelDates?.departureDate | finDateFormat: 'DATE' }}
            <span *ngIf="search?.travelDates?.returnDate">
              - {{ search?.travelDates?.returnDate | finDateFormat: 'DATE' }}</span
            >
          </div>
        </button>

        <button
          (click)="removePreviousSearchByCreationDate$.next(search.creationDate)"
          title="{{ 'actions.remove' | finLocalization }}"
          [attr.aria-controls]="'previous-search-' + index"
          [attr.aria-label]="
            'bookingSearch.deletePreviousSearchRoute'
              | finLocalization
                : {
                    origin: search?.origin?.cityName,
                    destination: search?.destination?.cityName,
                    date:
                      (search.travelDates.departureDate | finDateFormat: 'DATE').toString() +
                      (search?.travelDates?.returnDate
                        ? ' - ' + (search?.travelDates?.returnDate | finDateFormat: 'DATE')?.toString()
                        : '')
                  }
          "
          data-test-remove-previous-search-button
        >
          <fcom-icon name="trash" class="icon-medium"></fcom-icon>
        </button>
      </li>
    </ul>
  </div>
</ng-container>
